<div class="dialog-header">
  <h2 mat-dialog-title>Availability reminder</h2>
  <button
    mat-icon-button
    type="button"
    aria-label="Dismiss availability reminder"
    (click)="dismiss()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p>{{ message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="takeMeToAvailability()">
    Take me to Availability
  </button>
</mat-dialog-actions>
